import Vue from 'vue';
import VueRouter from 'vue-router';
import Login from "@/views/Login.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: '/login',
    name: 'login',
    component: Login,
  },
  {
    path: '/jhl-admin',
    name: 'jhl-admin',
    component: () => import(/* webpackChunkName: "customer-service" */ '@/views/JhlAdmin.vue'),
  },
  {
    path: '/customer-service',
    name: 'customer-service',
    component: () => import(/* webpackChunkName: "customer-service" */ '@/views/CustomerService.vue'),
  },
  {
    path: '/customer-premium-service',
    name: 'customer-premium-service',
    component: () => import(/* webpackChunkName: "customer-service" */ '@/views/CustomerPremiumService.vue'),
  },
  {
    path: '/customer-products',
    name: 'customer-products',
    component: () => import(/* webpackChunkName: "customer-products" */ '@/views/CustomerProductMix.vue'),
  },
  {
    path: '/hub-products',
    name: 'hub-products',
    component: () => import(/* webpackChunkName: "hub-products" */ '@/views/HubProductMix.vue'),
  },
  {
    path: '/service-costs',
    name: 'service-costs',
    component: () => import(/* webpackChunkName: "hub-products" */ '@/views/ServiceCosts.vue'),
  },
  {
    path: '/revenue-margin',
    name: 'revenue-margin',
    component: () => import(/* webpackChunkName: "hub-products" */ '@/views/RevenueMargin.vue'),
  },
  {
    path: '/postcode-products',
    name: 'postcode-products',
    component: () => import(/* webpackChunkName: "customer-products" */ '@/views/PostcodeProductMix.vue'),
  },
  {
    path: '/postcode-margin',
    name: 'postcode-margin',
    component: () => import(/* webpackChunkName: "customer-products" */ '@/views/PostcodeMargin.vue'),
  },
  {
    path: '/postcode-products-general',
    name: 'postcode-products-general',
    component: () => import(/* webpackChunkName: "customer-products" */ '@/views/PostcodeProductMixGeneral.vue'),
  },
  {
    path: '/customer-product-margin',
    name: 'customer-product-margin',
    component: () => import(/* webpackChunkName: "customer-products" */ '@/views/ProductMargin.vue'),
  },
  {
    path: '/customer-unit-margin',
    name: 'customer-unit-margin',
    component: () => import(/* webpackChunkName: "customer-products" */ '@/views/RevenuePerUnit.vue'),
  },
  {
    path: '/depot-dashboard/:depot',
    name: 'depot-customer-dashboard',
    component: () => import('@/views/DepotCustomerDashboard.vue'),
    props: true,
  },
  // {
  //     path: '/depot-dashboard',
  //     name: 'depot-dashboard',
  //     component: () => import('@/views/DepotDashboard.vue'),
  // },
  {
    path: '/network-and-revenue',
    name: 'network-and-revenue',
    component: () => import('@/views/NetworkAndRevenue.vue'),
  },
  {
    path: '/new-business',
    name: 'new-business',
    component: () => import('@/views/NewBusiness.vue'),
  },
  {
    path: '/new-business-revenue-margin',
    name: 'new-business-revenue-margin',
    component: () => import('@/views/NewBusinessRevenueMargin.vue'),
  },
  {
    path: '/non-trading-customers',
    name: 'non-trading-customers',
    component: () => import('@/views/NonTradingCustomers.vue'),
  },
  {
    path: '/year-on-year',
    name: 'year-on-year',
    component: () => import('@/views/YearOnYearBreakdown.vue'),
  },
  {
    path: '/transport-planning',
    name: 'transport-planning',
    component: () => import('@/views/TransportPlanning.vue'),
  },
  {
    path: '/budget',
    name: 'budget',
    component: () => import('@/views/Budget.vue'),
  },
  {
    path: '/customer-weekly-pallets',
    name: 'customer-weekly-pallets',
    component: () => import('@/views/CustomerWeeklyPallets.vue'),
  },
  {
    path: '/customer-weekly-gross-margin',
    name: 'customer-weekly-gross-margin',
    component: () => import('@/views/CustomerWeeklyGrossMargins.vue'),
  },
  {
    path: '/CB',
    name: 'central-billing-comparison',
    component: () => import('@/views/CentralBillingComparison.vue'),
  },
  {
    path: '/postcode-zones',
    name: 'postcode-zones',
    component: () => import('@/views/PostcodeZones.vue'),
  },
  {
    path: '/customer-rate-cards',
    name: 'customer-rate-cards',
    component: () => import('@/views/CustomerRateCards.vue'),
  },
  {
    path: '/customer-review-dashboard',
    name: 'customer-review-dashboard',
    component: () => import ('@/views/CustomerReviewDashboard.vue'),
    props: true,
  },
  {
    path: '/daily-billing-unit-dashboard',
    name: 'daily-billing-unit-dashboard',
    component: () => import ('@/views/DailyBillingUnitDashboard.vue'),
    props: true,
  },
  {
    path: '/daily-pallet-volume',
    name: 'daily-pallet-volume',
    component: () => import ('@/views/DailyPalletVolume.vue'),
    props: true,
  },
  {
    path: '/tiered-customers',
    name: 'tiered-customers',
    component: () => import ('@/views/TieredCustomers.vue'),
    props: true,
  },
  {
    path: '/customer-portfolio',
    name: 'customer-portfolio',
    component: () => import ('@/views/CustomerPortfolio.vue'),
    props: true,
  },
  {
    path: '/price-comparison',
    name: 'price-comparison',
    component: () => import('@/views/PriceComparison.vue'),
  },
  {
    path: '/',
    name: 'root',
    redirect: { name: 'customer-service' },
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
